import type { LeadStage } from './api';

/** Blueprint §6.2 order, mirrored from the API's lead-stage.ts. */
export const PIPELINE_ORDER: readonly LeadStage[] = [
  'NEW_LEAD',
  'CONTACTED',
  'INTERESTED',
  'TEST_RIDE',
  'QUOTATION_SENT',
  'BOOKING_RECEIVED',
  'LOAN_PROCESSING',
  'APPROVED',
  'READY_DELIVERY',
  'DELIVERED',
];

/** NKS's own words, not the enum. Staff should never read NEW_LEAD on screen. */
export const STAGE_LABEL: Record<LeadStage, string> = {
  NEW_LEAD: 'New lead',
  CONTACTED: 'Contacted',
  INTERESTED: 'Interested',
  TEST_RIDE: 'Test ride',
  QUOTATION_SENT: 'Quotation sent',
  BOOKING_RECEIVED: 'Booking received',
  LOAN_PROCESSING: 'Loan processing',
  APPROVED: 'Approved',
  READY_DELIVERY: 'Ready for delivery',
  DELIVERED: 'Delivered',
  LOST: 'Lost',
};

export const SOURCE_LABEL: Record<string, string> = {
  META: 'Meta',
  WEBSITE: 'Website',
  WHATSAPP: 'WhatsApp',
  WALK_IN: 'Walk-in',
  ROADSHOW: 'Roadshow',
  REFERRAL: 'Referral',
  REPEAT: 'Repeat customer',
  MANUAL: 'Entered manually',
};

/**
 * Status colour, from the reserved band in antd-theme.ts. Deliberately not the
 * primary colour: this product is mostly status, and a stage that reads as a
 * brand colour tells the reader nothing.
 */
export function stageTone(stage: LeadStage): string | undefined {
  if (stage === 'LOST') return 'error';
  if (stage === 'DELIVERED') return 'success';
  if (stage === 'NEW_LEAD') return undefined;
  return 'processing';
}

/** The next stage forward, for the one-tap advance button. */
export function nextStage(stage: LeadStage): LeadStage | null {
  const index = PIPELINE_ORDER.indexOf(stage);
  if (index === -1 || index === PIPELINE_ORDER.length - 1) return null;
  return PIPELINE_ORDER[index + 1] ?? null;
}
